export enum WizardStep {
  DETAILS = 'Basic Info',
  FIELDS = 'Build',
  CALENDARS = 'Assign',
}

export const WizardStepUrlPart: Record<WizardStep, string> = {
  [WizardStep.DETAILS]: '',
  [WizardStep.FIELDS]: 'fields',
  [WizardStep.CALENDARS]: 'assign',
};
